import "./schedule-custom.scss";
import React, { useEffect, useState } from "react";
import { DataGrid, GridMoreVertIcon } from "@mui/x-data-grid";
import { RxCross1, RxPlus } from "react-icons/rx";
import { FaDownload, FaFilter } from "react-icons/fa6";
import {
  Box,
  Button,
  Checkbox,
  IconButton,
  MenuItem,
  Modal,
  Popover,
  gridClasses,
  styled,
} from "@mui/material";
import AddEditSchedule from "../../../components/Schedule/AddForm/AddEditSchedule";
import DeleteModal from "../../../components/Model/DeleteModal";
import { HttpService } from "../../../service/HttpService";
import { useAuth } from "../../../context/AuthProvider";
import { HiOutlineEye } from "react-icons/hi2";
import { CiEdit } from "react-icons/ci";
import { GoTrash } from "react-icons/go";
import { useFilter } from "../../../context/FilterProvider";
import FullScreenLoader from "../../../components/Loader/FullScreenLoader";
import DateTimeModal from "./DateTimeModal";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { Encryption } from "../../../Mixin/EncryptDecryptId";
import { useNavigate } from "react-router-dom";
import utc from "dayjs/plugin/utc";
import { handleDownloadExcel } from "../../../Mixin/downloadExcel";
import { handleDownloadScheduleExcel } from "../handleDownloadScheduleExcel";
import { FaFileExcel } from "react-icons/fa";
import { TbAlertHexagonFilled } from "react-icons/tb";
dayjs.extend(utc);

const Schedule = () => {
  const dateFilterData = JSON.parse(localStorage.getItem("dateFilter"));
  const [rows, setRows] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [openDelete, setOpenDelete] = useState(false);
  const [isAdd, setIsAdd] = useState(false);
  const [clickedschedule, setClickedschedule] = useState("");
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [schedule_id, setSchedule_id] = useState("");
  const [dataId, setDataId] = useState();
  const [anchorEl, setAnchorEl] = useState(null);
  const { setShowLoginPopup, showLoginPopup } = useAuth();
  const httpService = new HttpService(setShowLoginPopup);
  const { company_id, location_id } = useFilter();
  const [openDateModal, setOpenDateModal] = useState(false);
  const [startDate, setStartDate] = useState(
    dateFilterData?.startDate || dayjs().startOf("month").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    dateFilterData?.endDate || dayjs().endOf("month").format("YYYY-MM-DD")
  );
  const [deleteSchedule, setDeleteSchedule] = useState("");
  const [selectedRadio, setSelectedRadio] = useState(
    dateFilterData?.selectedRadio || "month"
  );
  const [pageSize, setPageSize] = useState(15);
  const [rowCount, setRowCount] = useState("");
  const [page, setPage] = useState(0);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [selectedId, setSelectedId] = useState([]);
  const [allIds, setAllIds] = useState(0);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  // const [isModalAlert, setIsModalAlert] = useState(false);
  // const closeAlertModal = () => setIsModalAlert(false);

  // const searchSchedules = (searchTerm) => {
  //   const searchTermLowerCase = searchTerm.toLowerCase();
  //   const results =
  //     rows?.length > 0 &&
  //     rows?.filter((item) => {
  //       for (let key in item) {
  //         if (
  //           typeof item[key] === "string" &&
  //           item[key].toLowerCase().includes(searchTermLowerCase)
  //         ) {
  //           return true;
  //         }
  //       }
  //       return false;
  //     });
  //   if (results) {
  //     setSearchData(results);
  //   }
  // };

  const fetchSchedule = () => {
    setLoading(true);
    httpService
      .get(
        `schedule/get_schedule?page=${
          page + 1
        }&pageSize=${pageSize}&start_date=${startDate}&end_date=${endDate}&search=${searchData}`
      )
      .then((response) => {
        setRows(response?.data?.data);
        // setSearchData(response?.data);
        setRowCount(response?.data?.totalRecords);
        setTimeout(() => {
          setLoading(false);
        }, 300);
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching data:", error);
      });
  };

  useEffect(() => {
    const dateFilterData = JSON.parse(localStorage.getItem("dateFilter"));
    if (dateFilterData) {
      setStartDate(dateFilterData?.startDate);
      setEndDate(dateFilterData?.endDate);
      setSelectedRadio(dateFilterData?.selectedRadio);
    } else {
      const dateFilter = {
        startDate: dayjs().startOf("month").format("YYYY-MM-DD"),
        endDate: dayjs().endOf("month").format("YYYY-MM-DD"),
        selectedRadio: "month",
      };
      localStorage.setItem("dateFilter", JSON.stringify(dateFilter));
    }
    fetchSchedule();
    setAllIds(0);
  }, [location_id, company_id, showLoginPopup, page, pageSize, searchData]);

  const handleOpen = () => {
    setOpen(true);
    setIsAdd(true);
    setClickedschedule("");
  };

  const handleOpenDateTimeModal = () => {
    setOpenDateModal(true);
  };
  const handleClose = () => {
    setOpen(false);
    setIsAdd(false);
    setClickedschedule("");
    setOpenDelete(false);
    setSchedule_id("");
  };

  const handleDateTimeModal = () => {
    setOpenDateModal(false);
  };

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const StyledGridOverlay = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    "& .ant-empty-img-1": {
      fill: theme.palette.mode === "light" ? "#aeb8c2" : "#262626",
    },
    "& .ant-empty-img-2": {
      fill: theme.palette.mode === "light" ? "#f5f5f7" : "#595959",
    },
    "& .ant-empty-img-3": {
      fill: theme.palette.mode === "light" ? "#dce0e6" : "#434343",
    },
    "& .ant-empty-img-4": {
      fill: theme.palette.mode === "light" ? "#fff" : "#1c1c1c",
    },
    "& .ant-empty-img-5": {
      fillOpacity: theme.palette.mode === "light" ? "0.8" : "0.08",
      fill: theme.palette.mode === "light" ? "#f5f5f5" : "#fff",
    },
  }));

  function CustomNoRowsOverlay() {
    return (
      <StyledGridOverlay>
        <Box sx={{ mt: 1 }}>No Data Found</Box>
      </StyledGridOverlay>
    );
  }

  const other = {
    showCellVerticalBorder: true,
    showColumnVerticalBorder: true,
  };

  const HandleDeleteSchedule = async () => {
    if (deleteSchedule) {
      try {
        const response = await httpService.delete(
          `${"schedule/delete_schedule"}/${deleteSchedule}`
        );
        if (response?.success === true) {
          toast.success("Schedule Deleted successfully", {
            position: "top-right",
          });
          fetchSchedule();
        } else {
          throw response;
        }
        setOpenDelete(false);
        fetchSchedule();
      } catch (error) {
        setOpenDelete(false);
        toast.error(error?.response?.data?.error, {
          position: "top-right",
        });
      }
    }
  };

  const navigate = useNavigate();
  const viewPage = (id) => {
    const urlEncodedId = Encryption(id);
    navigate(`view/${urlEncodedId}`, { state: { from: "scheduleModule" } });
  };

  const onDownloadClick = async () => {
    try {
      await handleDownloadScheduleExcel(setShowLoginPopup);
    } catch (error) {
      console.error("Error downloading Excel:", error);
    }
  };

  const handleHeaderCheckboxChange = (event) => {
    const isChecked = event.target.checked;
    if (isChecked) {
      const allIds = rows.map((row) => row.id); // Get all the IDs from the data
      setSelectedId(allIds); // Select all IDs
      setAllIds(allIds.length);
    } else {
      setSelectedId([]);
      setAllIds(0);
    }

    setIsAllSelected(isChecked);
  };
  const deleteSelectedSchedule = async () => {
    if (selectedId?.length > 0) {
      try {
        const response = await httpService.post(
          "schedule/delete_all_schedule",
          { schedule_ids: selectedId }
        );
        if (response?.success) {
          fetchSchedule();
          setSelectedId([]);
          setIsAllSelected(false);
          setAllIds(0);
          toast.success(response?.message, {
            position: "top-right",
          });
        } else {
          throw response;
        }
        fetchSchedule();
        setOpenDeleteModal(false);
      } catch (error) {
        setOpenDeleteModal(false);
        setSelectedId([]);
        setAllIds(0);
        toast.error(error?.response?.data?.error, {
          position: "top-right",
        });
      }
    } else {
      toast.error("Please select atleast one schedule", {
        position: "top-right",
      });
    }
  };

  const toggleId = (id) => {
    const allIds = rows.map((row) => row.id);

    if (selectedId?.includes(id)) {
      // Remove the id from selectedId
      const updatedSelectedIds = selectedId.filter((item) => item !== id);

      setSelectedId(updatedSelectedIds);
      setIsAllSelected(updatedSelectedIds.length === allIds.length);
      setAllIds(allIds.length);

      return updatedSelectedIds;
    } else {
      // Add the id to selectedId
      const updatedSelectedIds = [...selectedId, id];

      setSelectedId(updatedSelectedIds);
      setIsAllSelected(updatedSelectedIds.length === allIds.length);
      setAllIds(allIds.length);

      return updatedSelectedIds;
    }
  };

  const isIdSelected = (id) => {
    return selectedId.includes(id);
  };

  return (
    <>
      {loading && <FullScreenLoader />}
      <div className="schedule">
        <div className="page-title">
          <div className="title-wrap">
            <h1>Schedules</h1>
          </div>
          <div className="button-wrap">
            <button
              type="submit"
              className="btn btn-primary"
              onClick={() => handleOpen()}
            >
              <RxPlus /> Add Schedule{" "}
            </button>
            <button
              type="submit"
              className="filter-btn-custm"
              onClick={() => handleOpenDateTimeModal()}
            >
              <FaFilter />
            </button>
          </div>
        </div>
        <div className="table-filter-wrap d-flex justify-content-between">
          <Button
            className="btn btn-delete"
            onClick={() => {
              if (selectedId?.length > 0) {
                setOpenDeleteModal(true);
              } else {
                toast.error("Please select atleast one schedule", {
                  position: "top-right",
                });
              }
            }}
          >
            Delete
          </Button>
          <div className="d-flex flex-row">
            <Button
              variant="contained"
              color="primary"
              onClick={() => onDownloadClick()}
              startIcon={<FaFileExcel />}
              className="me-3"
            >
              Download
            </Button>
            <div className="header_search-wrap">
              <div className="header_search_bar common_content">
                <div className="input-group input_group">
                  <button className="btn search-btn search_btn">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="15"
                      height="15"
                      viewBox="0 0 21 21"
                      fill="none"
                    >
                      <circle
                        cx="9.98856"
                        cy="9.98856"
                        r="8.98856"
                        stroke="#495057"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M16.2402 16.7071L19.7643 20.222"
                        stroke="#495057"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </button>
                  <input
                    type="search"
                    className="form-control form_control"
                    placeholder="Search..."
                    aria-label="Search"
                    onChange={(e) => {
                      const value = e.target.value;
                      setSearchData(value);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          style={{
            height: `${rows?.length > 0 ? "" : "200px"}`,
            width: "100%",
          }}
        >
          <DataGrid
            slots={{
              noRowsOverlay: CustomNoRowsOverlay,
            }}
            rows={
              rows?.length > 0 &&
              rows?.map((row, index) => ({
                ...row,
                id: row.id,
                sequenceNumber: index + 1,
              }))
            }
            getRowHeight={() => "auto"}
            sx={{
              [`& .${gridClasses.cell}`]: {
                py: 0.5,
              },
            }}
            columns={[
              {
                field: "action",
                headerName: "Action",
                headerAlign: "center",
                width: 100,
                align: "center",
                sortable: false,
                disbableColumnMenu: true,
                renderCell: (params) => (
                  <>
                    <div className="action_icon-weap">
                      <IconButton
                        onClick={(e) => {
                          handleMenuClick(e);
                          setDataId(params.row.id);
                        }}
                      >
                        <GridMoreVertIcon />
                      </IconButton>
                    </div>
                    {anchorEl && dataId === params?.row?.id && (
                      <Popover
                        className="popup-menu"
                        key={dataId}
                        open={Boolean(anchorEl)}
                        anchorEl={anchorEl}
                        onClose={handleCloseMenu}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "right",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "right",
                        }}
                      >
                        <MenuItem
                          onClick={() => {
                            viewPage(dataId);
                          }}
                          className="menu-list-items"
                        >
                          <div className="menu-list-items-text">View</div>
                          <HiOutlineEye style={{ cursor: "pointer" }} />
                        </MenuItem>
                        <MenuItem
                          onClick={() => {
                            setOpen(true);
                            setIsAdd(false);
                            setSchedule_id(dataId);
                            handleCloseMenu();
                          }}
                          className="menu-list-items"
                        >
                          <div className="menu-list-items-text">Edit</div>
                          <CiEdit style={{ cursor: "pointer" }} />
                        </MenuItem>
                        <MenuItem
                          onClick={() => {
                            setOpenDelete(true);
                            setDeleteSchedule(dataId);
                            handleCloseMenu();
                          }}
                          className="menu-list-items"
                        >
                          <div className="menu-list-items-text">Delete</div>
                          <GoTrash style={{ cursor: "pointer" }} />
                        </MenuItem>
                        <MenuItem
                          onClick={() => {
                            handleDownloadExcel(dataId, setShowLoginPopup),
                              handleCloseMenu();
                          }}
                          className="menu-list-items"
                        >
                          <div className="menu-list-items-text">Download</div>
                          <FaDownload style={{ cursor: "pointer" }} />
                        </MenuItem>
                      </Popover>
                    )}
                  </>
                ),
              },
              {
                field: "select_All",
                headerName: "Select All",
                minWidth: 150,
                align: "center",
                sortable: false,
                disableColumnMenu: true,
                renderCell: (params) => {
                  return (
                    <Checkbox
                      value="Checked"
                      checked={
                        isAllSelected
                          ? true
                          : isIdSelected(params.row.id)
                          ? true
                          : false
                      }
                      onChange={() => toggleId(params.row.id)}
                    />
                  );
                },
                headerCheckboxSelection: true,
                renderHeader: (params) => {
                  return (
                    <>
                      <Checkbox
                        checked={isAllSelected}
                        onChange={(e) => handleHeaderCheckboxChange(e)}
                      />
                      <strong>Select All</strong>
                    </>
                  );
                },
              },
              {
                field: "name",
                headerName: "Schedule Name",
                minWidth: 250,
                flex: 1,
                renderCell: (params) => {
                  return <div>{params.row.name ? params.row.name : "--"}</div>;
                },
              },
              {
                field: "plant_name",
                headerName: "Plant",
                minWidth: 250,
                flex: 1,
                renderCell: (params) => {
                  return (
                    <div>
                      {params.row?.plant_name_alias
                        ? params.row?.plant_name_alias
                        : params.row?.plant_name
                        ? params.row?.plant_name
                        : "--"}
                    </div>
                  );
                },
              },
              {
                field: "room_name",
                headerName: "Room",
                minWidth: 300,
                flex: 1,
                renderCell: (params) => {
                  return (
                    <div>
                      {params.row?.room_name_alias
                        ? params.row?.room_name_alias
                        : params.row?.room_name
                        ? params.row?.room_name
                        : "--"}
                    </div>
                  );
                },
              },
              {
                field: "ongoing",
                headerName: "On-Going",
                headerAlign: "center",
                align: "center",
                minWidth: 280,
                flex: 1,
                renderCell: (params) => {
                  return <div>{params.row.ongoing ? "On-Going" : "--"}</div>;
                },
              },
              {
                field: "start_date",
                headerName: "Start Date",
                headerAlign: "center",
                align: "center",
                minWidth: 280,
                flex: 1,
                renderCell: (params) => {
                  return (
                    <div>
                      {dayjs(params.row.adjusted_start_date).format(
                        "MMM/DD/YYYY"
                      )}
                    </div>
                  );
                },
              },
              {
                field: "end_date",
                headerName: "End Date",
                headerAlign: "center",
                align: "center",
                minWidth: 280,
                flex: 1,
                renderCell: (params) => {
                  return (
                    <div>
                      {dayjs(params.row.adjusted_end_date).format(
                        "MMM/DD/YYYY"
                      )}
                    </div>
                  );
                },
              },
            ]}
            initialState={{
              pagination: {
                rowCount: -1,
              },
            }}
            paginationMode="server"
            sortingMode="server"
            rowCount={rowCount}
            pageSizeOptions={[15, 50, 100]}
            paginationModel={{ pageSize: pageSize, page: page }}
            onPaginationModelChange={(event) => {
              setPage(event?.page);
              setPageSize(event?.pageSize);
            }}
            checkboxSelection={false}
            rowSelection={false}
            autoHeight
            {...other}
          />
        </div>
      </div>

      {open === true && (
        <AddEditSchedule
          open={open}
          isAdd={isAdd}
          schedule_id={schedule_id}
          clickedschedule={clickedschedule}
          handleClose={() => {
            handleClose();
            // setIsModalAlert(true);
            setSchedule_id("");
          }}
          fetchScheduleData={() => fetchSchedule()}
        />
      )}
      <DeleteModal
        open={openDelete}
        HandleClose={() => handleClose()}
        HandleDelete={() => {
          HandleDeleteSchedule(), setClickedschedule("");
        }}
      />

      {openDateModal && (
        <DateTimeModal
          handleDateTimeModal={() => handleDateTimeModal()}
          setStartDate={(e) => setStartDate(e)}
          setEndDate={(e) => setEndDate(e)}
          open={openDateModal}
          fetchSchedule={() => {
            fetchSchedule();
            const dateFilter = {
              startDate: startDate,
              endDate: endDate,
              selectedRadio: selectedRadio,
            };
            localStorage.setItem("dateFilter", JSON.stringify(dateFilter));
          }}
          selectedRadio={selectedRadio}
          setSelectedRadio={(e) => setSelectedRadio(e)}
          startDate={startDate}
          endDate={endDate}
        />
      )}
      {openDeleteModal && (
        <DeleteModal
          open={openDeleteModal}
          HandleClose={() => setOpenDeleteModal(false)}
          HandleDelete={() => {
            deleteSelectedSchedule();
          }}
        />
      )}
      {/* {isModalAlert && ( */}
      {/* <Modal open={isModalAlert} onClose={() => closeAlertModal()}>
          <div
            className="modal_block"
            style={{ height: "212px", width: "587px" }}
          >
            <div
              className="modal_header"
              style={{ padding: "27px 36px 10px", marginBottom: "0px" }}
            >
              <div className="modal_title_wrapper">
              </div>
              <div className="cancel-btn-wrap">
                <RxCross1
                  onClick={() => closeAlertModal()}
                  style={{ width: "22px", height: "22px" }}
                />
              </div>
            </div>
            <div
              className="modal_content d-flex justify-content-center"
              style={{ height: "69px" }}
            >
              <div className="modal_content_inner">
                <div>
                  <TbAlertHexagonFilled />
                </div>
                <div>
                  <p>Please assign Mother Plant for Take Clone</p>
                </div>
              </div>
            </div>
            <div className="modal_footer">
              <button
                onClick={() => closeAlertModal()}
                className="btn btn-primary"
              >
                Okay
              </button>
            </div>
          </div>
        </Modal> */}
      {/* )} */}
    </>
  );
};

export default Schedule;
